/** @jsx $jsx */
import { $jsx } from 'framework7';
function framework7Component(props, {
  $,
  $el,
  $f7,
  $f7ready
}) {
  const initializeViews = function () {
    // Main application view
    $f7.views.create($el.value.find('#view-main'), {
      name: 'main',
      main: true,
      url: '/',
      initRouterOnTabShow: true,
      preloadPreviousPage: false,
      auroraSwipeBack: false,
      iosSwipeBack: false,
      mdSwipeBack: false,
      animate: !$f7.device.ios
    });

    // Sidebar view
    $f7.views.create($el.value.find('#view-sidebar'), {
      name: 'sidebar',
      main: false
    });

    // Sidebar panel
    $f7.panel.create({
      el: $el.value.find('#sidebar'),
      swipe: true,
      swipeActiveArea: 64,
      visibleBreakpoint: 1024,
      collapsedBreakpoint: 768
    });

    // Load sidebar route
    $f7.views.sidebar.router.navigate('/sidebar/');
  };
  $f7ready(function () {
    //initializeViews();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div id="app">

        <!-- Sidebar -->
        ${$f7.config.layout[$f7.config.layout.default].sidebar.enabled && $h`
        <div id="sidebar" class="panel panel-cover panel-left">
            <div id="view-sidebar" class="view view-sidebar view-init" data-url="/sidebar/"></div>
        </div>
        `}


        <!-- If Single View Layout Is Set As Default -->
        ${$f7.config.layout.default == 'singleView' && $h`
        <div id="view-main" class="view view-main view-init"></div>
        `}

        <!-- If Tab View Layout Is Set As Default -->
        ${$f7.config.layout.default == 'tabView' && $h`
        <div class="views tabs safe-areas">
            <div id="tabbar" class="toolbar toolbar-bottom tabbar tabbar-labels color-theme-mono">
                <div class="toolbar-inner">
                    ${Object.entries($f7.config.tabs).map(([slug, tab], i) => $h`
                    <a href="#view-${slug}" class="tab-link tab-link-active">
                        <span class="icons">
                            <i class="icon f7-icons">${tab.icon}</i>
                            <i class="icon icon-active f7-icons">${tab.iconActive}</i>
                        </span>
                        <span class="tabbar-label" data-i18n="${slug}">${tab.title}</span>
                    </a>
                    `)}
                </div>
            </div>
            ${Object.entries($f7.config.tabs).map(([slug, tab], i) => $h`
            <div id="view-${slug}" class="view view-${slug} tab"></div>
            `)}
        </div>
        `}



    </div>
`
    }
    ;
}
framework7Component.id = '61b088bfc0';
export default framework7Component;